import getters from "./getters"
import actions from "./actions"
import state from "./state"
import mutations from "./mutations"
import { ModuleTree } from "vuex"
import { RootState } from ".."

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as ModuleTree<RootState>
